import { useState, useEffect, useCallback, useRef } from 'react';
import { getOnboardingConfiguration, submitOnboardingStep, resetOnboardingStep } from '../../../../libs/fetch.js';
import Step from './OnboardingStep.jsx';
import FormSkeleton from '../../../FormSkeleton.jsx';

const OnboardingConfiguration = (props) => {
  const { connection_id, permissions = [] } = props;
  const [loading, setLoading] = useState(true);
  const [submittingStepId, setSubmittingStepId] = useState(null);
  const pollingRef = useRef(null);

  // Helper function to process steps (filter visible and sort by step_number)
  const processSteps = (stepsArray) => {
    return stepsArray
      ?.filter((step) => step.step_template.is_visible)
      .sort((a, b) => (a.step_number || 0) - (b.step_number || 0));
  };

  const [onboardingConfig, setOnboardingConfig] = useState(null);
  const steps = processSteps(onboardingConfig?.steps) || [];
  const currentStepId =
    onboardingConfig?.current_onboarding_configurations_step_id || null;
  const currentStep = steps.find((step) => step.id === currentStepId) || {};
  // pending, submitted, running, finished, failed
  const currentStepStatus = currentStep.status || null;

  // Fetch onboarding configuration
  const fetchOnboardingConfig = useCallback(async () => {
    try {
      const config = await getOnboardingConfiguration(connection_id);
      if (config) {
        setOnboardingConfig(config);
      }
    } catch (error) {
      console.error('Error fetching onboarding configuration:', error);
    } finally {
      setLoading(false);
    }
  }, [connection_id]);

  // Initial fetch
  useEffect(() => {
    fetchOnboardingConfig();
  }, [fetchOnboardingConfig]);

  // Conditional polling effectI thi
  useEffect(() => {
    if (currentStepStatus === 'submitted' || currentStepStatus === 'running') {
      const intervalId = setInterval(fetchOnboardingConfig, 5000);
      pollingRef.current = intervalId;
      return () => {
        clearInterval(intervalId);
        pollingRef.current = null;
      };
    }
  }, [currentStepStatus, fetchOnboardingConfig]);

  const handleSubmit = async (event, step) => {
    setSubmittingStepId(step.id);

    if (pollingRef.current) {
      clearInterval(pollingRef.current);
      pollingRef.current = null;
    }

    try {
      const status = step.status;
      const formData = event.formData;
      if (formData && formData.totpCode) {
        delete formData.totpCode;
      }
      if (status === 'pending' || status === 'failed') {
        const resp = await submitOnboardingStep(
          step.id,
          formData,
          step.step_template?.schema
        );
        if (resp) {
          setOnboardingConfig(resp);
          return;
        }
      } else {
        const resp = await resetOnboardingStep(step.id);
        if (resp) {
          setOnboardingConfig(resp);
          return;
        }
      }
    } catch (error) {
      console.error('Error submitting step:', error);
    } finally {
      setSubmittingStepId(null);
    }
  };

  const Steps = () => {
    return steps.map((step, index) => (
      <Step
        key={step.id}
        step={step}
        isCurrentStep={currentStepId === step.id}
        handleSubmit={handleSubmit}
        isLastStep={index === steps.length - 1}
        isSubmitting={submittingStepId === step.id}
        permissions={permissions}
      />
    ));
  };

  return loading ? (
    <FormSkeleton />
  ) : (
    <div className='space-y-6 p-6'>
      <div>{Steps()}</div>
    </div>
  );
};

export default OnboardingConfiguration;
